export default __webpack_public_path__ + "static/media/orange-pigzpay-logo.48a79e9d.svg";